import { useState, useEffect } from 'react';

const initialData = {
  q: null,
  page: 1,
  count: 0,
  next: false,
  prev: false,
  params: {},
  results: [],
};

const _getter = () => new Error('Getter is required');

/**
 * @param {func} getter Function to get data
 * @param {object} config
 * @param {boolean} config.auto Auto fetch first page
 * @param {string|number} config.selfValue
 * @param {boolean} config.onlyOnePage
 * @param {object} config.params
 * @returns [] [data, fetchData, loading]
 */
const usePaginatedFetcher = (getter = _getter, config = {}) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(config.auto || false);

  const getDistinctResults = (_results) => [...new Set(_results.map(({ id }) => id))]
    .map((id) => _results.find((e) => e.id === id));

  const fetchData = async (page = 1, q = null, _params = null) => {
    const params = { ...config.params, ..._params };
    params.page = page;
    if (q) {
      params[config?.qName || 'q'] = q;
    }
    const samePage = page === data.page && !(page === 1 && data.page === 1);
    const sameQ = q === data.q;
    if (!(samePage && sameQ)) {
      setLoading(true);
      const _data = await getter(params);
      setLoading(false);
      if (page !== 1 && !config.onlyOnePage) {
        setData((prev) => ({
          q,
          page,
          count: _data?.count,
          params,
          next: Boolean(_data.next),
          prev: Boolean(_data.next),
          results: getDistinctResults([...prev.results, ..._data.results]),
        }));
        return _data;
      }
      setData({
        q: _data.q || null,
        page,
        count: _data.count,
        params,
        next: Boolean(_data.next),
        prev: Boolean(_data.prev),
        results: _data.results,
      });
      return _data;
    }
    return data;
  };

  useEffect(() => {
    if (config.auto && !config.selfValue) {
      fetchData();
    }
  }, []);

  return [data, fetchData, loading];
};

export default usePaginatedFetcher;
